import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const Header = styled.header`
  width: 100%;
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Footer = styled.div`
  /* margin-top: 300px; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonStep = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;
